import { render } from "./BasicAccordion.vue?vue&type=template&id=766003a8&scoped=true"
import script from "./BasicAccordion.vue?vue&type=script&lang=js"
export * from "./BasicAccordion.vue?vue&type=script&lang=js"

import "./BasicAccordion.vue?vue&type=style&index=0&id=766003a8&lang=scss&scoped=true"

import exportComponent from "/builds/intratone/interface/intratoneinfov4/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-766003a8"]])

export default __exports__